import React from 'react';

export const API_BASE = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:3001/api';

// Helper to render <option> tags from dropdownOptions
export function renderOptions(options, placeholder) {
  return (
    <>
      {placeholder && <option value="">{placeholder}</option>}
      {(options || []).map(opt => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </>
  );
}

// Helper: determine if an entity record is "active"
export function isEntityActive(type, record) {
  switch (type) {
    case 'contact':
      return record.Status !== 'Inactive';
    case 'property':
      return record.Status !== 'Inactive';
    case 'lead':
      return !['Closed-Won', 'Closed-Lost'].includes(record.Status);
    case 'contract':
      return !['Completed', 'Terminated', 'Expired'].includes(record.Status);
    case 'reminder':
      return record.Status !== 'Completed';
    default:
      return true;
  }
}

// Status filter toggle: Show All / Show Active / Show Inactive
export function StatusFilter({ value, onChange }) {
  const options = ['Active', 'All', 'Inactive'];
  return (
    <div className="crm-status-filter">
      {options.map(opt => (
        <button
          key={opt}
          onClick={() => onChange(opt)}
          className={`crm-status-filter__btn ${value === opt ? 'crm-status-filter__btn--active' : ''}`}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}

export function capitalizeFirst(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}
